import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-bag01',
  standalone: true,
  templateUrl: '../../assets/bag01.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamBag01Icon {}
